import { render, staticRenderFns } from "./TeamLevelList.vue?vue&type=template&id=4b2a1830&scoped=true"
import script from "./TeamLevelList.vue?vue&type=script&lang=js"
export * from "./TeamLevelList.vue?vue&type=script&lang=js"
import style0 from "./TeamLevelList.vue?vue&type=style&index=0&id=4b2a1830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a1830",
  null
  
)

export default component.exports